import { configureRTQStore } from '@mint-lib/rtk-query-client';
import createSagaMiddleware from 'redux-saga';

import { apiSlice } from '../api/apiSlice.js';
import { currenciesApi } from '../api/currenciesApi.js';
import { insertionOrderApi } from '../api/insertionOrderApi.js';
import api from './middleware/api.js';
import rootReducer from './reducer/index.js';
import rootSaga from './sagas/index.js';

const sagaMiddleware = createSagaMiddleware();

const store = configureRTQStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({}).concat(
      api,
      sagaMiddleware,
      apiSlice.middleware,
      insertionOrderApi.middleware,
      currenciesApi.middleware,
    ),
});

sagaMiddleware.run(rootSaga);

export default store;
